module.exports = __webpack_public_path__ + "static/media/conversion-page.f06c74c6.svg";